module.exports = __webpack_public_path__ + "static/media/client4.dc02dbbf.png";